class modalRetrieveCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, logger, retrieveService) {
        $scope.obj = items1.obj
        $scope.diskCode = items1.diskCode
        $scope.standaloneFlag = items1.standaloneFlag
        console.log(items1.obj)
        $scope.cancel = () => {
            $uibModalInstance.dismiss()
            // $uibModalInstance.close();
        }
        httpRequest.get_dictByTypeArr(['stock_inv_type']).then((res) => {
            $scope.dictData = res.data.value
        })
        $scope.modalRetrieveSubmit = function modalRetrieveSubmit() {
            // 退回
            if ($scope.diskCode != 0 && ($scope.standaloneFlag || $scope.obj.ukeyCode == 0)) {
                retrieveService.retreatInvoiceBranch($scope.obj, $scope.diskCode).then((res) => {
                    logger.logSuccess('发票退回成功！')
                    $uibModalInstance.close()
                }, (err) => {
                    logger.logError(err)
                })
            } else if ($scope.diskCode != 0) { // 服务器版收回
                retrieveService.post_returnServerDiskInvoiceFromUkey($scope.obj, $scope.diskCode).then((res) => {
                    logger.logSuccess('发票退回成功！')
                    $uibModalInstance.close()
                }, (err) => {
                    logger.logError(err)
                })
            } else { // 主盘收回
                retrieveService.mainRetrieve($scope.obj).then((res) => {
                    logger.logSuccess('发票收回成功！')
                    $uibModalInstance.close()
                }, (err) => {
                    logger.logError(err)
                })
            }
        }
    }
}

modalRetrieveCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest', 'logger', 'retrieveService']
export default modalRetrieveCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/retrieve/modalRetrieveCtrl.js